<div class="row">
    <div class="col-md-12">
        <h5>{{ 'general.working_hours' | translate }}</h5>
    </div>
</div>

<div class="work-row">
    <div></div>
    <div>{{ 'general.monday' | translate }}</div>
    <div>{{ 'general.tuesday' | translate }}</div>
    <div>{{ 'general.wednesday' | translate }}</div>
    <div>{{ 'general.thursday' | translate }}</div>
    <div>{{ 'general.friday' | translate }}</div>
    <div>{{ 'general.saturday' | translate }}</div>
    <div>{{ 'general.sunday' | translate }}</div>
</div>
<div class="work-row">
    <div>{{ 'general.start_work' | translate }}</div>
    <div>
        <p-dropdown [options]="workingHours" [(ngModel)]="model.MondayStart"></p-dropdown>
    </div>
    <div>
        <p-dropdown [options]="workingHours" [(ngModel)]="model.TuesdayStart"></p-dropdown>
    </div>
    <div>
        <p-dropdown [options]="workingHours" [(ngModel)]="model.WednesdayStart"></p-dropdown>
    </div>
    <div>
        <p-dropdown [options]="workingHours" [(ngModel)]="model.ThursdayStart"></p-dropdown>
    </div>
    <div>
        <p-dropdown [options]="workingHours" [(ngModel)]="model.FridayStart"></p-dropdown>
    </div>
    <div>
        <p-dropdown [options]="workingHours" [(ngModel)]="model.SaturdayStart"></p-dropdown>
    </div>
    <div>
        <p-dropdown [options]="workingHours" [(ngModel)]="model.SundayStart"></p-dropdown>
    </div>
</div>
<div class="work-row">
    <div>{{ 'general.end_work' | translate }}</div>
    <div>
        <p-dropdown [options]="workingHours" [(ngModel)]="model.MondayEnd"
                    (ngModelChange)="replicateCheck()"></p-dropdown>
    </div>
    <div>
        <p-dropdown [options]="workingHours" [(ngModel)]="model.TuesdayEnd"></p-dropdown>
    </div>
    <div>
        <p-dropdown [options]="workingHours" [(ngModel)]="model.WednesdayEnd"></p-dropdown>
    </div>
    <div>
        <p-dropdown [options]="workingHours" [(ngModel)]="model.ThursdayEnd"></p-dropdown>
    </div>
    <div>
        <p-dropdown [options]="workingHours" [(ngModel)]="model.FridayEnd"></p-dropdown>
    </div>
    <div>
        <p-dropdown [options]="workingHours" [(ngModel)]="model.SaturdayEnd"></p-dropdown>
    </div>
    <div>
        <p-dropdown [options]="workingHours" [(ngModel)]="model.SundayEnd"></p-dropdown>
    </div>
</div>
<div class="row margin-top-8" *ngIf="model.TechnicianID">
    <div class="col-md-10"></div>
    <div class="col-md-2">
        <button pButton type="button" class="p-button-raised full-width"
                label="{{ 'bikeshop.modal.add_edit_user.technician_working_hours_form.save_hours' | translate }}"
                (click)="saveHours()" [disabled]="busy"></button>
    </div>
</div>
<p-confirmDialog key="confirm_times"></p-confirmDialog>
